/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/jsx-no-target-blank */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SvgIcon, Text, TextStyles } from "@cinch-labs/design-system";
import { Wrapper } from "@cinch-nx/shared-ui";
import Link from "next/link";
import { Head } from "@cinch-nx/landing-ui-shared";
import { JargonContent, KeywordList, RelatedJargon } from "./components";
import styles from "./jargon.module.css";
import { isJargonHubStoryContent } from "./utils/is-jargon-hub-story-content";
import { usePrefersReducedMotion } from "@cinch-nx/shared-ui";
import { Skeleton } from "@mui/material";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
const siteUrl = "https://www.cinch.co.uk/";
export const JargonFeature = ({ story , preview =false  })=>{
    var ref;
    const prefersReducedMotion = usePrefersReducedMotion();
    const { content , slug  } = useStoryblokState({
        story: story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    if (!content || !isJargonHubStoryContent(content) || !story) {
        return /*#__PURE__*/ _jsx("article", {
            className: styles.page,
            children: /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        sx: {
                            marginTop: "24px",
                            marginBottom: "16px"
                        },
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        width: 500,
                        height: 56
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        sx: {
                            marginBottom: "56px"
                        },
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        width: 300,
                        height: 30
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        animation: prefersReducedMotion ? false : "wave",
                        variant: "rectangular",
                        className: styles.skeleton
                    })
                ]
            })
        });
    } else {
        var ref1;
        const { fullTerm , term , question , answer , image , keywords , summary  } = content;
        const reducedRelatedJargon = (ref1 = story.rels) === null || ref1 === void 0 ? void 0 : ref1.map((relatedStory)=>{
            var ref, ref1, ref2, ref3;
            return {
                slug: relatedStory.slug ?? "",
                content: {
                    summary: ((ref = relatedStory.content) === null || ref === void 0 ? void 0 : ref.summary) ?? "",
                    question: ((ref1 = relatedStory.content) === null || ref1 === void 0 ? void 0 : ref1.question) ?? "",
                    keywords: ((ref2 = relatedStory.content) === null || ref2 === void 0 ? void 0 : ref2.keywords) ?? "",
                    fullTerm: ((ref3 = relatedStory.content) === null || ref3 === void 0 ? void 0 : ref3.fullTerm) ?? ""
                }
            };
        });
        const keywordList = keywords === null || keywords === void 0 ? void 0 : keywords.split(",").map((p)=>p.trim());
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Head, {
                    ...SEO,
                    fallbackTitle: `${fullTerm} - cinch`,
                    fallbackDescription: summary
                }),
                /*#__PURE__*/ _jsx("article", {
                    className: styles.page,
                    children: /*#__PURE__*/ _jsxs(Wrapper, {
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.header,
                                children: [
                                    /*#__PURE__*/ _jsx(Link, {
                                        href: "/jargon",
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ _jsxs("a", {
                                            className: styles.headerLink,
                                            children: [
                                                /*#__PURE__*/ _jsx(SvgIcon, {
                                                    name: "chevron-left",
                                                    height: 12,
                                                    color: "toreaBay"
                                                }),
                                                "All Jargon"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Link, {
                                        href: `mailto:?subject=${question} - Cinch&body=${siteUrl}/jargon/${slug}`,
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ _jsxs("a", {
                                            target: "_blank",
                                            className: styles.headerLink,
                                            children: [
                                                /*#__PURE__*/ _jsx(SvgIcon, {
                                                    name: "share",
                                                    height: 16,
                                                    gradient: "newGalaxy"
                                                }),
                                                "Share by Email"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("h1", {
                                className: styles.fullTerm,
                                children: [
                                    fullTerm,
                                    term && ` (${term})`
                                ]
                            }),
                            keywordList && keywordList.length > 0 && /*#__PURE__*/ _jsx(KeywordList, {
                                items: keywordList
                            }),
                            /*#__PURE__*/ _jsx(JargonContent, {
                                question: question,
                                answer: answer,
                                image: image
                            }),
                            story.rels && story.rels.length > 0 && reducedRelatedJargon && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: styles.title,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            element: "h2",
                                            type: TextStyles.mainTitle,
                                            lineHeight: "display",
                                            children: "Related Jargon"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(RelatedJargon, {
                                        items: reducedRelatedJargon
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
};
